<div class="attach-picker" role="dialog" aria-modal="true" aria-labelledby="attach-picker-title">
  <div class="attach-picker__head">
    <span class="attach-picker__title" id="attach-picker-title">{{ 'NOVA_ATTACH_CONTEXT' | translate }}</span>
    <button type="button" class="attach-picker__close" (click)="dismiss.emit()" [attr.aria-label]="'CLOSE' | translate">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>

  <!-- In-scope context rows (meeting analysis, transcript, spotlight, etc.) -->
  <ng-container *ngIf="contextAttachments.length">
    <p class="attach-picker__zone-label">{{ 'NOVA_CURRENT_CONTEXT' | translate }}</p>
    <button
      *ngFor="let ctx of contextAttachments; trackBy: trackByKindId"
      type="button"
      class="attach-picker__row attach-picker__row--context"
      [class.attach-picker__row--attached]="isAttached(ctx)"
      [attr.aria-pressed]="isAttached(ctx)"
      (click)="toggle.emit(ctx)">
      <ion-icon [name]="iconFor(ctx.kind)"></ion-icon>
      <span class="attach-picker__row-content">
        <span class="attach-picker__row-label">{{ ctx.label }}</span>
        <span class="attach-picker__row-sub">{{ subLabelKey(ctx.kind) | translate }}</span>
      </span>
      <!-- Checkmark when attached; kind tag when not attached -->
      <ion-icon
        *ngIf="isAttached(ctx)"
        name="checkmark-circle"
        class="attach-picker__check">
      </ion-icon>
      <span
        *ngIf="!isAttached(ctx)"
        class="attach-picker__kind"
        [class.attach-picker__kind--accent]="ctx.kind === 'meeting'">{{ kindTagKey(ctx.kind) | translate }}</span>
    </button>
  </ng-container>

  <!-- Divider between context rows and search zone -->
  <div class="attach-picker__divider" *ngIf="contextAttachments.length"></div>

  <!-- Search field — pill styled via ion-searchbar CSS vars -->
  <p class="attach-picker__zone-label">{{ 'SEARCH' | translate }}</p>
  <ion-searchbar
    class="attach-picker__searchbar"
    [placeholder]="'NOVA_SEARCH_CONTACTS_ACCOUNTS' | translate"
    [debounce]="250"
    (ionInput)="onSearch($event.detail.value)">
  </ion-searchbar>

  <div class="attach-picker__results">
    <button *ngFor="let r of results; trackBy: trackByKindId" type="button" class="attach-picker__row" (click)="pickResult(r)">
      <ion-icon [name]="iconFor(r.kind)"></ion-icon>
      <span>{{ r.label }}</span>
      <ion-icon *ngIf="isAttached(r)" name="checkmark-circle" class="attach-picker__check"></ion-icon>
      <span *ngIf="!isAttached(r)" class="attach-picker__kind">{{ kindTagKey(r.kind) | translate }}</span>
    </button>
    <p class="attach-picker__empty" *ngIf="query && !results.length && !searching">{{ 'NOVA_NO_SEARCH_RESULTS' | translate }}</p>
  </div>
</div>
